// React Lib
import React from "react";
import classnames from 'classnames';
// Component Styles
import { useStyles } from "./BreadcrumbStyles";
// @otg-one/ui_components/components
import { Typography } from "../index";
// @otg-one/ui_components/icons
import { ChevronRight } from "../../sap_icons";
// @otg-one/ui_components/constants
import { Color, FONT_FAMILY } from "../../constants";
export const Breadcrumb = (props) => {
    const classes = useStyles(props);
    const { id, stacks, style, handleChangeBreadcrumb } = props;
    const handleStackClick = (index) => () => {
        if (handleChangeBreadcrumb) {
            handleChangeBreadcrumb("POP", stacks[index]);
        }
        else {
            stacks[index].onClick();
        }
    };
    return (React.createElement("div", { className: classes.breadcrumbContainer, style: style, id: id }, stacks.map((stack, index) => {
        var _a;
        const breadcrumbStackContainerClasses = classnames({
            [classes.breadcrumbStackContainer]: index !== stacks.length - 1,
            [classes.breadcrumbStackContainerLastOfType]: index === stacks.length - 1
        });
        const typeOf = (_a = stack.label) === null || _a === void 0 ? void 0 : _a.toUpperCase();
        return (React.createElement(React.Fragment, { key: `stack${index}` },
            index !== 0 && (React.createElement(ChevronRight, { className: classes.breadcrumbChevronRight })),
            React.createElement("div", { onClick: handleStackClick(index), style: {
                    marginTop: stack.typeOf !== "" ? -6 : 'auto'
                } },
                (stack.typeOf !== "" || stack.typeof !== undefined) && (React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, size: 10, color: index === stacks.length - 1 ? Color.neutral[500] : Color.neutral[300], className: classes.breadcrumbTypographyHeader }, typeOf ? typeOf : stack.type)),
                React.createElement("div", { className: breadcrumbStackContainerClasses },
                    stack.icon,
                    React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM_BOLD, size: 16, color: index === stacks.length - 1 && Color.neutral[900], style: {
                            cursor: index !== stacks.length - 1 && "pointer"
                        }, className: classes.breadcrumbLabel }, stack.label)))));
    })));
};
Breadcrumb.defaultProps = {
    stacks: [],
};
export default React.memo(Breadcrumb);
